module.exports = __webpack_public_path__ + "img/hangye1.2061ca6e.png";